var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightgreen02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #9ba658;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m23.17,61.24c4.48-1.36,7.74-5.52,7.74-10.45,0-6.03-4.89-10.92-10.92-10.92s-10.92,4.89-10.92,10.92c0,4.93,3.26,9.09,7.74,10.45-8.7,2.02-11.3,10.01-11.3,23.11h28.94c0-13.1-2.6-21.09-11.3-23.11Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m48.12,15.66c-9.03,0-16.36,6.22-16.36,13.9,0,2.32.67,4.51,1.86,6.44l-3.29,7.26c-.08.17-.05.38.07.52.09.11.23.17.37.17.04,0,.09,0,.13-.02l8.76-2.47c2.46,1.26,5.35,1.99,8.44,1.99,9.03,0,16.36-6.22,16.36-13.9s-7.32-13.9-16.36-13.9Zm-6.99,16.4c-1.38,0-2.5-1.12-2.5-2.5s1.12-2.5,2.5-2.5,2.5,1.12,2.5,2.5-1.12,2.5-2.5,2.5Zm6.84,0c-1.38,0-2.5-1.12-2.5-2.5s1.12-2.5,2.5-2.5,2.5,1.12,2.5,2.5-1.12,2.5-2.5,2.5Zm7.13,0c-1.38,0-2.5-1.12-2.5-2.5s1.12-2.5,2.5-2.5,2.5,1.12,2.5,2.5-1.12,2.5-2.5,2.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightgreen02);
export default __webpack_public_path__ + "static/media/lightgreen02.92729ccab3948d58c5be0fe2acc3e0b9.svg";
export { ForwardRef as ReactComponent };